let API_URL = process.env.REACT_APP_API_URL;
let API_KEY = process.env.REACT_APP_API_KEY;

export const getRoznamaByDate = async (date) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'getRoznamaByDate',
                apiKey: API_KEY,
                origin: window.location.origin,
                date: date
            }),
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching roznama:', error);
        return { success: false, error: error.message };
    }
};

// UPDATED: Close Roznama Day with Fine Balance
export const closeRoznamaDay = async (
    date,
    openingBalanceCash,
    openingBalanceBank,
    openingBalanceFine,  // NEW
    incomeTransactions,
    expenseTransactions,
    closingBalanceBank,
    closingBalanceCash,
    closingBalanceFine,  // NEW
    netProfit,
    totalIncome,
    totalExpense
) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'closeRoznamaDay',
                apiKey: API_KEY,
                origin: window.location.origin,
                date,
                openingBalanceCash,
                openingBalanceBank,
                openingBalanceFine,  // NEW
                incomeTransactions,
                expenseTransactions,
                closingBalanceBank,
                closingBalanceCash,
                closingBalanceFine,  // NEW
                netProfit,
                totalExpense,
                totalIncome
            }),
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error closing roznama day:', error);
        return { success: false, error: error.message };
    }
};

// UPDATED: Add Roznama Day with Fine Balance
export const addRoznamaDay = async (roznamaData) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'addRoznama',
                apiKey: API_KEY,
                origin: window.location.origin,
                date: roznamaData.date,
                openingBalanceCash: roznamaData.openingBalanceCash || 0,
                openingBalanceBank: roznamaData.openingBalanceBank || 0,
                openingBalanceFine: roznamaData.openingBalanceFine || 0,  // NEW
                closingBalanceCash: roznamaData.closingBalanceCash || 0,
                closingBalanceBank: roznamaData.closingBalanceBank || 0,
                closingBalanceFine: roznamaData.closingBalanceFine || 0,  // NEW
                incomeTransactions: roznamaData.incomeTransactions || [],
                expenseTransactions: roznamaData.expenseTransactions || [],
                netProfit: roznamaData.netProfit || 0,
                totalIncome: roznamaData.totalIncome || 0,
                totalExpense: roznamaData.totalExpense || 0
            }),
        });

        const jsonResponse = await response.json();
        if (jsonResponse?.success === true) {
            let data = roznamaData;
            data.id = jsonResponse?.data?.id;
            jsonResponse.data = data;
        }
        console.log('Add Roznama Response:', response);
        return jsonResponse;
    } catch (error) {
        console.error('Error adding roznama:', error);
        return { success: false, error: error.message };
    }
};

// UPDATED: Update Roznama Day with Fine Balance
export const updateRoznamaDay = async (id, roznamaData) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'updateRoznama',
                apiKey: API_KEY,
                origin: window.location.origin,
                id,
                date: roznamaData.date,
                openingBalanceCash: roznamaData.openingBalanceCash || 0,
                openingBalanceBank: roznamaData.openingBalanceBank || 0,
                openingBalanceFine: roznamaData.openingBalanceFine || 0,  // NEW
                closingBalanceCash: roznamaData.closingBalanceCash || 0,
                closingBalanceBank: roznamaData.closingBalanceBank || 0,
                closingBalanceFine: roznamaData.closingBalanceFine || 0,  // NEW
                incomeTransactions: roznamaData.incomeTransactions || [],
                expenseTransactions: roznamaData.expenseTransactions || [],
                netProfit: roznamaData.netProfit || 0,
                totalIncome: roznamaData.totalIncome || 0,
                totalExpense: roznamaData.totalExpense || 0
            }),
        });

        const jsonResponse = await response.json();
        if (jsonResponse?.success === true) {
            let data = roznamaData;
            data.id = jsonResponse?.data?.id;
            jsonResponse.data = data;
        }
        console.log('Update Roznama Response:', response);
        return jsonResponse;
    } catch (error) {
        console.error('Error updating roznama:', error);
        return { success: false, error: error.message };
    }
};

export const deleteRoznamaDay = async (id) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'deleteRoznama',
                apiKey: API_KEY,
                origin: window.location.origin,
                id
            }),
        });

        return await response.json();
    } catch (error) {
        console.error('Error deleting roznama:', error);
        return { success: false, error: error.message };
    }
};

export const recalculateRoznamas = async (date) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'recalculateRoznamas',
                apiKey: API_KEY,
                origin: window.location.origin,
                date: date
            }),
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error recalculating roznamas:', error);
        return { success: false, error: error.message };
    }
};